import React, { useState, useEffect } from "react";
import figlet from "figlet";
import Big from "figlet/importable-fonts/Big";
import Footer from "../component/Footer";
import "../Text Modification Formatting/text.css";

figlet.parseFont("Big", Big);

const BigTextConverter = () => {
  const [textareaValue, setTextareaValue] = useState("");
  const [convertedText, setConvertedText] = useState("");

  useEffect(() => {
    figlet.parseFont("Big", Big);
  }, []);

  const handleChange = (event) => {
    setTextareaValue(event.target.value);
    convertToFiglet(event.target.value);
  };

  const convertToFiglet = (text) => {
    figlet.text(text, { font: "Big" }, (err, result) => {
      if (err) {
        console.error("Error during figlet conversion:", err);
        setConvertedText("Error converting text");
        return;
      }
      setConvertedText(result);
    });
  };

  const handleDownload = () => {
    const blob = new Blob([convertedText], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "figlet-text.txt";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const calculateTextStatistics = () => {
    const text = textareaValue;

    const words = text
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0);
    const letters = text.replace(/\s+/g, "").length;
    const sentences = text
      .split(/[.!?]+/)
      .filter((sentence) => sentence.trim().length > 0);
    const lines = text.split("\n");

    return {
      wordCount: words.length,
      letterCount: letters,
      sentenceCount: sentences.length,
      lineCount: lines.length,
    };
  };

  return (
    <div className="container">
      <main>
        <h1>Rabbit Case</h1>
        <div className="content">
          <h2>Big Text Converter</h2>
          <p>
            Experience the magic of transforming plain text into captivating
            figlet fonts with our big text generator. Elevate your messages,
            announcements, and designs to new heights by unleashing the
            creativity and impact of stylish text formatting.
          </p>
          <div className="textarea-container">
            <textarea
              className="textarea-animated"
              value={textareaValue}
              onChange={handleChange}
              placeholder="Start typing your notes here..."
              rows="8"
            />
            <textarea
              className="textarea-animated"
              value={convertedText}
              placeholder="Converted text will appear here..."
              rows="8"
              readOnly
            />
          </div>
          
          <div className="stats-text">
            Words: {calculateTextStatistics().wordCount} | Letters:{" "}
            {calculateTextStatistics().letterCount} | Sentences:{" "}
            {calculateTextStatistics().sentenceCount} | Lines:{" "}
            {calculateTextStatistics().lineCount}
          </div>

          <div className="btn1-container">
            <button class="btn-421" onClick={handleDownload}>
              Download Text
            </button>
            <button
              class="btn-421"
              onClick={() => navigator.clipboard.writeText(convertedText)}
            >
              Copy to Clipboard
            </button>
            <button class="btn-421" onClick={() => setTextareaValue("")}>
              Clear
            </button>
          </div>
          
        </div>
        <br />
        <div className="content1">
          <h3>How the Big Text Converter Works?</h3>
          <p>
            Our Big Text Generator simplifies the task of transforming plain
            text into captivating figlet fonts, offering a seamless and
            efficient solution. Users input their desired text, and our tool
            instantly converts it into stylish and attention-grabbing designs.
            With a single font option available, customization remains
            straightforward, allowing you to effortlessly enhance your messages,
            announcements, or designs with visually engaging figlet fonts.
          </p>
          <p>
            This tool is particularly suited for GitHub READMEs, enabling users
            to effortlessly create eye-catching headers and titles, instantly
            grabbing the attention of visitors and enhancing the overall
            appearance of their project documentation.
          </p>
        </div>
        <br />
        <div className="content1">
          <h3>What is a Figlet font?</h3>
          <p>
            A Figlet font is a collection of ASCII characters designed to create
            large, stylized text when displayed in a terminal or other
            text-based interface. These fonts typically consist of characters
            formed from various combinations of smaller ASCII characters,
            allowing for the creation of decorative and eye-catching text-based
            designs. Figlet fonts are commonly used for decorative purposes in
            terminal-based applications, ASCII art, banners, and other
            text-heavy contexts where visual presentation is desired.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default BigTextConverter;
